import { useSelector } from 'react-redux';
import { getCreatorId } from '../ducks';

export const useGetCreatorId = (battleId: number) => ({
  creatorId: useSelector(getCreatorId(battleId)),
});
